/* DropdownTriggerWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./DropdownTriggerWrapper.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
var triggerWrapperStylesWithPadding = null;
var triggerWrapperStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
var triggerWrapperStylesUnbounded = null;
export function ToolbarDropdownTriggerWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([fg('platform-visual-refresh-icons') ? "_1e0c1txw _u5f3v77o" : "_1e0c1txw", "_1fvdglyw"])
  }, children);
}